export default __webpack_public_path__ + "img/bcPCcAci.02ab0dc1.svg";